import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { isNil, omit } from 'lodash';
import { productActions } from '../../store/modules/product';
import ProductExcelBulkEditWrap from '../../views/product/excel/bulk/edit/ProductExcelBulkEditWrap';
import {
  DISCOUNT_TYPE,
  MAXIMUM_NUMBER_OF_BULK_EDIT_PRODUCT,
  PRODUCT_UNLIMITED_STOCK_VALUE,
} from '../../constants/service/app/productConstants';
import { PRODUCT_TAG_GROUP_KIND_LIST } from '../../constants/service/app/tagConstants';
import { asyncSimpleModal, setIfNull } from '../../lib/common';

class ProductExcelBulkEditContainer extends Component {
  /**
   *  유효성 검사
   */
  validateTest = (file) => {
    const { setData, getBulkEditProductValidateResultList } = this.props;

    /**
     *  엑셀 파일 네임 업데이트
     */
    setData({
      path: ['excelBulkEditProduct', 'file'],
      value: file,
    });

    /**
     *  유효성 검사
     */
    getBulkEditProductValidateResultList({
      attachment: [file],
    });
  };

  /**
   *  업데이트하기
   */
  bulkEditProduct = async () => {
    const { excelBulkEditProduct, bulkEditProduct } = this.props;
    const { bulkEditProductValidResultList, bulkEditProductValidResultCount } = excelBulkEditProduct;

    /**
     *  최대 400개의 상품만 일괄 편집하게 제한
     */
    if (bulkEditProductValidResultCount.success > MAXIMUM_NUMBER_OF_BULK_EDIT_PRODUCT) {
      message.error(`엑셀 상품 일괄 편집은 최대 ${MAXIMUM_NUMBER_OF_BULK_EDIT_PRODUCT}개 까지 가능합니다.`);
    } else if (bulkEditProductValidResultCount.failed) {
      message.error('업데이트 할 상품이 존재하지 않습니다.');
    } else {
      const bulkEditProductConfirmResult = await asyncSimpleModal({
        type: 'confirm',
        title: '상품 일괄 편집 하시겠습니까?',
        message: `상품 일괄 편집 작업을 다시 돌이킬 수 없습니다. \n그래도 정말 하시겠습니까?`,
      });

      if (bulkEditProductConfirmResult) {
        /**
         *  상품 옵션 정보를 리스트 형태로 가공
         */
        let optionBufferList = [];
        const bulkEditList = bulkEditProductValidResultList.reduce((accumulator, item, index) => {
          /**
           *  3. 옵션정보를 제외한 정보를 리스트에 추가하기전 임시 옵션 리스트가 있는 경우
           *  이전 옵션 정보를 제외한 정보에 optionList를 추가
           */
          if (item.no && optionBufferList.length) {
            accumulator[accumulator.length - 1].optionList = optionBufferList;
            optionBufferList = [];
          }

          /**
           *  1. 옵션 정보를 제외하고 나머지 정보만 리스트에 추가
           */
          if (item.no) {
            accumulator.push(
              omit(item, ['optionName', 'optionPrice', 'optionStockCount', 'optionStatus', 'optionNumber']),
            );
          }

          /**
           *  2. 옵션 정보가 있는 경우 임시 옵션 리스트에 추가
           */
          if (item.optionName && item.optionPrice && item.optionStatus) {
            optionBufferList.push({
              name: item.optionName,
              price: item.optionPrice,
              stockCount: isNil(item.optionStockCount) ? PRODUCT_UNLIMITED_STOCK_VALUE : item.optionStockCount,
              status: item.optionStatus.id,
              number: setIfNull(item.optionNumber),
            });
          }

          /**
           *  4. 마지막 index 인 경우 기존에 임시 옵션 리스트가 존재하는 경우에 추가
           */
          if (index === bulkEditProductValidResultList.length - 1 && optionBufferList.length) {
            accumulator[accumulator.length - 1].optionList = optionBufferList;
          }

          return accumulator;
        }, []);

        bulkEditProduct({
          bulkEditProductList: bulkEditList.map((item) => {
            /**
             *  업데이트에 필요한 데이터 생성
             */
            const discountType = item.discountTypeUnit
              ? !isNil(item.discountTypeUnit.id)
                ? item.discountTypeUnit.id
                : null
              : null;
            let discountAmount,
              discountRate = null;

            /**
             * 정액 할인
             */
            if (discountType === DISCOUNT_TYPE.FIXED_AMOUNT_DISCOUNT) {
              discountAmount = item.discountValue;
              discountRate =
                (item.discountValue / item.originPrice) * 100 < 1
                  ? 1
                  : Math.floor((item.discountValue / item.originPrice) * 100);
            } else if (discountType === DISCOUNT_TYPE.FIXED_RATE_DISCOUNT) {
              /**
               * 정률 할인
               */
              discountAmount = item.originPrice - item.salesPrice;
              discountRate = item.discountValue;
            }

            return {
              /**
               *  상품번호
               */
              productId: item.id,
              /**
               *  카테고리
               */
              categoryId: item.category.id,
              /**
               *  상품 상태
               */
              status: setIfNull(item.status, 'id'),
              /**
               *  상품명
               */
              name: item.name,
              /**
               *  판매가
               */
              originPrice: item.originPrice,
              /**
               *  할인 타입
               */
              discountType,
              /**
               *  할인액
               */
              discountAmount,
              /**
               *  할인율
               */
              discountRate,
              /**
               *  할인 시작일
               */
              discountStartDate: setIfNull(item.discountStartDate),
              /**
               *  할인 종료일
               */
              discountEndDate: setIfNull(item.discountEndDate),
              /**
               *  실판매가(할인된 판매가)
               */
              salesPrice: item.salesPrice,
              /**
               *  재고수량
               */
              stockCount: isNil(item.stockCount) ? PRODUCT_UNLIMITED_STOCK_VALUE : item.stockCount,
              /**
               *  제품번호
               */
              number: setIfNull(item.number),
              /**
               *  귀금속 장신구 여부
               */
              isExpensive: setIfNull(item.isExpensive, 'id'),
              /**
               *  제품이 귀걸이인 경우 귀를 뚫어야 되는 여부
               */
              needPierce: item.needPierce ? item.needPierce.id : 0,
              /**
               *  제품이 귀걸이인 경우 귀를 뚫지 않아도 되는 여부
               */
              needNotPierce: item.needNotPierce ? item.needNotPierce.id : 0,
              /**
               *  사이즈
               */
              size: item.size,
              /**
               *  중량
               */
              weight: setIfNull(item.weight),
              /**
               *  구매 시 유의 사항
               */
              notice: setIfNull(item.notice),
              /**
               *  주문 메시지
               */
              orderExampleMessage: setIfNull(item.orderExampleMessage),
              /**
               *  배송타입
               */
              deliveryType: setIfNull(item.deliveryType, 'id'),
              /**
               *  주문 시 제작 제품 여부
               */
              isOrderMade: !isNil(item.orderMadeDate) ? 1 : null,
              /**
               *  주문 시 제작 소요시간
               */
              orderMadeDate: setIfNull(item.orderMadeDate),
              /**
               *  바로 배송 기준 시간
               */
              directDeliveryTimeLimit: setIfNull(item.directDeliveryTimeLimit),
              /**
               *  A/S 안내
               */
              asInform: item.asInform,
              /**
               *  착용 시 주의 사항
               */
              caution: setIfNull(item.caution),
              /**
               *  품질보증 기준
               */
              qualityAssurance: setIfNull(item.qualityAssurance),
              /**
               *  제조자
               */
              manufacturer: item.manufacturer,
              /**
               *  제조국
               */
              origin: item.origin,
            };
          }),
          bulkEditProductOptionList: bulkEditList.map((item) => ({
            productId: item.id,
            optionKeyName: item.optionType,
            optionList:
              item.optionList &&
              item.optionList.map((option, index) => {
                return {
                  ...option,
                  no: index + 1,
                };
              }),
          })),
          bulkEditProductTagList: bulkEditList.map((item) => {
            const productTagInfo = PRODUCT_TAG_GROUP_KIND_LIST.reduce((accumulator, tagGroupType) => {
              accumulator[tagGroupType] = item[tagGroupType].id;
              return accumulator;
            }, {});

            return {
              productId: item.id,
              ...productTagInfo,
            };
          }),
        });
      }
    }
  };

  render() {
    const { excelBulkEditProduct } = this.props;

    return (
      <ProductExcelBulkEditWrap
        excelBulkEditProduct={excelBulkEditProduct}
        validateTest={this.validateTest}
        bulkEditProduct={this.bulkEditProduct}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    excelBulkEditProduct: state.product.excelBulkEditProduct,
  };
};

const mapDispatchToProps = {
  setData: productActions.setData,
  getBulkEditProductValidateResultList: productActions.getBulkEditProductValidateResultList,
  bulkEditProduct: productActions.bulkEditProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductExcelBulkEditContainer);
